import Api from 'utils/api'
import { buildUrl } from 'utils/helpers'
import { showErrorMessage, showInfoMessage } from 'store/ui/actions'
import * as actions from './actions'

export const fetchEmergencies = (page, limit, q) => async (dispatch) => {
  dispatch(actions.getEmergenciesRequest())
  try {
    const result = await Api.request(
      buildUrl('/emergencies', {
        page,
        limit,
        q,
      })
    )

    dispatch(actions.getEmergenciesSuccess(result))
    return Promise.resolve(result)
  } catch (err) {
    // const { message } = await err.json()
    dispatch(actions.getEmergenciesError(err))
    return Promise.reject(err)
  }
}

export const createEmergency = (params) => async (dispatch) => {
  dispatch(actions.createEmergencyRequest())
  try {
    const formData = new FormData()
    Object.entries(params).forEach(([k, v]) => {
      if (v) {
        formData.append(k.toString(), v)
      }
    })
    const result = await Api.request(`/emergencies`, {
      method: 'POST',
      body: formData,
      headers: new Headers(),
    })
    dispatch(fetchEmergencies())
    dispatch(showInfoMessage(result?.message))
    dispatch(actions.createEmergencySuccess(result))
    return Promise.resolve()
  } catch (err) {
    const { error } = await err.json()
    dispatch(showErrorMessage(error))
    dispatch(actions.createEmergencyError(error))
    return Promise.reject(err)
  }
}

export const getEmergencySounds = () => async (dispatch) => {
  try {
    const result = await Api.request(buildUrl('/audios'))
    return Promise.resolve(result)
  } catch (err) {
    const { error } = await err.json()
    dispatch(showErrorMessage(error))
    return Promise.reject(err)
  }
}

export const startEmergency = (id) => async (dispatch) => {
  try {
    const result = await Api.request(`/emergencies/${id}/start`, {
      method: 'POST',
    })
    dispatch(fetchEmergencies())
    dispatch(showInfoMessage(result?.message))
    return Promise.resolve()
  } catch (err) {
    const { error } = await err.json()
    dispatch(showErrorMessage(error))
    return Promise.reject(err)
  }
}

export const stopEmergency = (id) => async (dispatch) => {
  try {
    const result = await Api.request(`/emergencies/${id}/stop`, {
      method: 'POST',
    })
    dispatch(fetchEmergencies())
    dispatch(showInfoMessage(result?.message))
    return Promise.resolve()
  } catch (err) {
    const { error } = await err.json()
    dispatch(showErrorMessage(error))
    return Promise.reject(err)
  }
}

export const exportEmergency = (id, email) => async (dispatch) => {
  try {
    const result = await Api.request(`/emergencies/${id}/export`, {
      method: 'POST',
      body: JSON.stringify({ email }),
    })
    dispatch(showInfoMessage(result?.message))
    return Promise.resolve()
  } catch (err) {
    const { error } = await err.json()
    dispatch(showErrorMessage(error))
    return Promise.reject(err)
  }
}
